

































































































































































import { API } from "@/shared/api";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

export interface DatasourceConfig {
  apiEndpoint: string;
  displayExpr: string;
  valueExpr: string;
  endpointType: "backend" | "fixed";
}

@Component
export default class DatasourceConfigDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ required: true }) datasourceConfig!: DatasourceConfig;

  public config: DatasourceConfig = {
    apiEndpoint: "",
    displayExpr: "text",
    valueExpr: "value",
    endpointType: "backend",
  };

  public testingApi: boolean = false;
  public apiTestResults: any[] = [];
  public apiTestError: string | null = null;

  public get internalShow(): boolean {
    return this.value;
  }

  public set internalShow(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("value")
  onValueChanged(newVal: boolean) {
    if (newVal) {
      this.apiTestResults = [];
      this.apiTestError = null;
      this.config = { ...this.datasourceConfig };
    }
  }

  public async testApiEndpoint() {
    if (!this.config.apiEndpoint.trim()) {
      this.apiTestError = "Por favor ingresa un endpoint de API";
      return;
    }

    this.testingApi = true;
    this.apiTestError = null;
    this.apiTestResults = [];

    try {
      let data: any;

      if (this.config.endpointType === "backend") {
        const { ssmHttpService } = await import(
          "@/shared/services/http-service"
        );

        const endpoint = this.config.apiEndpoint.startsWith("/")
          ? this.config.apiEndpoint.replace("/", "")
          : this.config.apiEndpoint;

        data = await ssmHttpService.get(API.webApiBase + endpoint);
      } else {
        const response = await fetch(this.config.apiEndpoint);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        data = await response.json();
      }

      if (Array.isArray(data)) {
        this.apiTestResults = data;
      } else if (data && typeof data === "object") {
        const firstArrayProp = Object.keys(data).find((key) =>
          Array.isArray(data[key])
        );
        if (firstArrayProp) {
          this.apiTestResults = data[firstArrayProp];
        } else {
          this.apiTestResults = [data];
        }
      } else {
        throw new Error(
          "La respuesta de la API no es un array o objeto válido"
        );
      }

      if (this.apiTestResults.length === 0) {
        this.apiTestError = "La API no devolvió ningún dato";
      }
    } catch (error) {
      this.apiTestError =
        (error as any).message || "Error al conectar con la API";
      console.error("API Test Error:", error);
    } finally {
      this.testingApi = false;
    }
  }

  public save() {
    this.$emit("save", this.config);
    this.close();
  }

  public close() {
    this.apiTestResults = [];
    this.apiTestError = null;
    this.$emit("input", false);
  }
}
